
import stringToNumber from "src/utils/stringToNumber";
import yup from "src/utils/yup/extensionMethods";

const deleteSchema = (translate: Function) => yup.object().shape({
	mes001Titulo: yup.string()
		.required(translate("Titulo da análise não confere"))
		.oneOf([yup.ref("mes001TituloConfirmation")], translate("Titulo da análise não confere"))
});

const AddOrChangeSchema = (translate:Function) => yup.object().shape({
	mes001Titulo: yup.string()
		.required(translate("Título é requerido")).max(60, translate("Título deve conter no máximo 60 caracteres")),
	mes001Dtinicio:yup.date()
		.required(translate("Data Inicial é requerida"))
		.typeError(translate("Data Inicial com data inválida"))
		.nullable(),
	mes001Dtfim: yup.date()
		.required(translate("Data Final é requerida"))
		.typeError(translate("Data Final com data inválida"))
		.nullable()
		.when("mes001Dtinicio",(initialDate,schema) => initialDate ? schema.min(initialDate,translate("Data final não pode ser menor que a inicial")):schema),
	mes001Taa011Id:yup.number()
		.required(translate("A dimensão é obrigatória")),
	permissions:yup.array()
		.of(metbs004Schema(translate))
		.min(1,translate("Ao menos uma permissão deve ser informada"))
		.required(translate("Ao menos uma permissão deve ser informada"))
		.unique(translate("Usuários não podem ser repetidos"), (a: any) => a.mes004Efa005Id, (a: any) => !a.mes004Efa004Id)
		.unique(translate("Grupo de usuários não podem ser repetidos"), (a: any) => a.mes004Efa004Id, (a: any) => !a.mes004Efa005Id)
});

const metbs004Schema = (translate: Function) => yup.object().shape({
	mes004Efa004Id: yup.string()
		.transform((value,originalValue) => originalValue ? value : "")
		.when("mes004Efa005Id",(userId,schema) => !userId ? schema.required(translate("Grupo de usuário é requerido")):schema.nullable()),
	mes004Efa005Id: yup.string()
		.transform((value,originalValue) => originalValue ? value : "")
		.when("mes004Efa004Id",(groupId,schema) => !groupId ? schema.required(translate("Usuário é requerido")):schema.nullable()),
	mes004Permissao:yup.number()
		.transform((value,originalValue) => {
			if(!originalValue && originalValue !== 0 && originalValue !== "0")
				return null;
			return typeof originalValue !== "string" ? value : stringToNumber(originalValue);
		})
		.required(translate("Opção de permissão é requerida"))
		.typeError(translate("Opção de permissão está incorreta"))
		.oneOf([0,1,2], translate("Opção invalida"))
},[["mes004Efa005Id","mes004Efa004Id"]]);

export {deleteSchema,AddOrChangeSchema};
